import { GlSkeletonLoader } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'ReleaseSkeletonLoader',
    components: {
        GlSkeletonLoader
    }
};
